module.exports = __webpack_public_path__ + "static/img/101368.9a618b52.png";